import { Select, Stack, Text } from '@mantine/core';
import { i18n } from '@lingui/core';
import { IconChevronDown } from '@tabler/icons';
import { useContext } from 'react';
import SkeletonItems from '../../../Atoms/SkeletonItems';
import { QuestionnaireTemplateContext } from '../../../Service/Context/QuestionnaireTemplateContext';
import { DataS } from '../../../Service/DataS';
import { ContractSign, CustomerSignType } from '../../../Types/DocumentT';

const QuestionnaireTemplateSignatureSection = () => {
  const { loading, template, patchTemplate } = useContext(QuestionnaireTemplateContext);
  const { contractSign, customerSignType } = template ?? {};

  return (
    <>
      <Text weight="bolder" size="lg" mb="md" mt="md">
        Unterschrift
      </Text>
      <Text mb="md">Definieren Sie, wie die Signatur angezeigt/erfasst werden soll</Text>
      {loading && <SkeletonItems height={40} count={2} />}
      {!loading && (
        <Stack sx={{ maxWidth: 600 }}>
          <Select
            value={contractSign}
            label={i18n._('contract.sign')}
            data={DataS.getContractSignOptions(i18n)}
            onChange={(val: ContractSign) => patchTemplate({ contractSign: val })}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            rightSection={<IconChevronDown size={14} />}
            rightSectionWidth={25}
          />
          <Select
            disabled={contractSign === 'NONE'}
            value={customerSignType}
            label={i18n._('contract.sign.type')}
            data={DataS.getCustomerSignTypeOptions(i18n)}
            onChange={(val: CustomerSignType) => patchTemplate({ customerSignType: val })}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            rightSection={<IconChevronDown size={14} />}
            rightSectionWidth={25}
          />
        </Stack>
      )}
    </>
  );
};

export default QuestionnaireTemplateSignatureSection;
